<template>
  <div>
    <h5 style="text-align: center;">撤销上传操作--学科竞赛</h5>

    <el-table :data="logs" style="width: 100%" border>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="datetime_cn" label="上传时间" />
      <el-table-column prop="uuid" label="uuid" />

      <el-table-column label="操作" width="220">
        <template #default="scope">
          <el-button
            type="primary"
            size="small"
            @click="viewDetail(scope.row.uuid)"
          >
            查看详情
          </el-button>

          <el-button
            type="danger"
            size="small"
            @click="confirmDelete(scope.row.uuid)"
          >
            撤销
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- ✅ 详情弹窗 -->
    <el-dialog
      title="学科竞赛上传详情"
      v-model="detailVisible"
      width="85%"
    >
      <el-table
        :data="detailList"
        border
        style="width: 100%"
      >
        <el-table-column prop="Winner" label="获奖者" width="120" />
        <el-table-column prop="class" label="班级" width="120" />
        <el-table-column prop="AwardName" label="奖项名称" min-width="200" />
        <el-table-column prop="GradeName" label="奖项等级" width="150" />
        <el-table-column prop="mentor" label="指导教师" width="150" />
        <el-table-column prop="type" label="身份" width="100" />
        <el-table-column label="上传日期" width="120">
          <template #default="scope">
            {{ scope.row.up_year }}/{{ scope.row.up_month }}/{{ scope.row.up_day }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'LogsComp',
  data() {
    return {
      logs: [],
      detailVisible: false,
      detailList: [],
    }
  },

  mounted() {
    this.fetchLogs()
  },

  methods: {
    formatChineseDatetime(dtString) {
      const dt = new Date(dtString)
      if (isNaN(dt.getTime())) return dtString

      const Y = dt.getUTCFullYear()
      const M = String(dt.getUTCMonth() + 1).padStart(2, '0')
      const D = String(dt.getUTCDate()).padStart(2, '0')
      const h = String(dt.getUTCHours()).padStart(2, '0')
      const m = String(dt.getUTCMinutes()).padStart(2, '0')
      const s = String(dt.getUTCSeconds()).padStart(2, '0')

      return `${Y}年${M}月${D}日 ${h}:${m}:${s} CST`
    },

    // 获取撤销日志
    async fetchLogs() {
      try {
        const res = await axios.get('/api/logscomp')
        this.logs = res.data.map(item => ({
          ...item,
          datetime_cn: this.formatChineseDatetime(item.datetime),
        }))
      } catch {
        ElMessage.error('获取失败')
      }
    },

    // ✅ 查看详情
    async viewDetail(uuid) {
      try {
        const res = await axios.get(`/api/logscomp/detail/${uuid}`)
        this.detailList = res.data
        this.detailVisible = true
      } catch {
        ElMessage.error('获取详情失败')
      }
    },

    // 撤销确认
    confirmDelete(uuid) {
      ElMessageBox.confirm(
        '确定要撤销这条记录吗？',
        '确认撤销',
        { type: 'warning' }
      ).then(() => {
        this.deleteLog(uuid)
      })
    },

    // 撤销
    async deleteLog(uuid) {
      try {
        await axios.delete(`/api/logscomp/${uuid}`)
        ElMessage.success('撤销成功')
        this.fetchLogs()
      } catch {
        ElMessage.error('撤销失败')
      }
    },
  },
}
</script>